import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 480px;
    padding: ${theme.layout.spacing(2)};

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    gap: ${theme.layout.spacing(2)};

    p {
      margin: 0;
    }

    svg {
      color: ${theme.palette.warning.main};
      font-size: 56px;
    }

    footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${theme.layout.spacing(1)};
    }

    button {
      width: 280px;
    }
  `}
`;
